import "../css/index.scss";

import "./fonts";
import "./header";
import "./prototypes";
import "./swipe.events";
import "./accordion";

import validationMessages from "./validation-messages";
import Bouncer from "formbouncerjs";

import { bm_hooks } from "./hooks";
import { initProduct } from "./product";
import { initCart } from "./cart";
import { initCheckout } from "./checkout";
import { verticalScroller } from "./vertical-scroller";
import { verticalAutoSlider } from "./vertical-auto-slider";
import { initLister } from "./lister";
import { quantityInput } from "./quanity-input";

// for complex version change QuantityStaffel
import { QuantityStaffel } from "./quantity-staffel";
// import { QuantityStaffelComplex } from "./qunatity-staffel-complex";
// import { initVariationPopup } from "./variation-popup";

import { tooltip } from "./tooltip";
import { initPopups } from "./popups";

bm_hooks.doAction("bm_js_load");
document.addEventListener("DOMContentLoaded", function () {
    bm_hooks.doAction("bm_pre_init");
    init();
    bm_hooks.doAction("bm_post_init");
});

const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (
            mutation.attributeName === "class" &&
            mutation.target.classList.contains("show")
        ) {
            const id = mutation.target.id;
            QuantityStaffel(id);
            mutation.target
                .querySelector(".discount-percentage")
                .classList.add("hidden");
            const scrollVertical =
                mutation.target.querySelectorAll(".scroll-vertical");
            if (scrollVertical.length) {
                scrollVertical.forEach((el) => {
                    initScrollers();
                });
            }
        }
    });
});

document.querySelectorAll(".wpvp-popup").forEach((el) => {
    observer.observe(el, {
        attributes: true,
        attributeFilter: ["class"],
    });
});

function init() {
    initUspSlider();
    initScrollers();
    initMenuScrolled();
    initFormChecks();
    initTooltips();
    initPopups();
    // initVariationPopup();
    initLister();
    initAjaxVariations();
    initProduct();
    initCartQuantity();
    initCart();
    initCheckout();
    QuantityStaffel();
    // QuantityStaffelComplex();

}

function getScrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
}

function initMenuScrolled() {
    var minScroll = 200;
    var lastScrollTop = 0;
    var diff = 0;
    var timeout, classTimer, scrolledTimer, diff_timer;
    var dir = "down";
    var st = getScrollTop();
    var enabled = true;

    var header = document.getElementById("main-header");
    var initHeaderHeight = header.clientHeight;

    window.addEventListener(
        "scroll",
        function () {
            st = getScrollTop();

            if (timeout) {
                window.cancelAnimationFrame(timeout);
            }

            timeout = window.requestAnimationFrame(scrollFrame);
        },
        false,
    );

    header.addEventListener("click", function () {
        header.classList.remove("up", "down");
        enabled = false;
        setTimeout(function () {
            enabled = true;
        }, 500);
    });

    function scrollFrame() {
        if (enabled) {
            var currHeaderHeight = header.clientHeight;
            var headerHeightDiff =
                Number(initHeaderHeight) - Number(currHeaderHeight);
            var calcSt = Number(st || 0) + Number(headerHeightDiff);

            clearTimeout(scrolledTimer);
            scrolledTimer = setTimeout(function () {
                header.classList.toggle("scrolled", calcSt > minScroll);
            }, 100);

            // check for min diff of 2 pixels (chaning height causes rounding diff)
            if (Math.abs(calcSt - lastScrollTop) > 2) {
                if (calcSt >= lastScrollTop) {
                    dir = "down";
                } else if (st <= lastScrollTop) {
                    dir = "up";
                }
            }

            if (dir == "down" && calcSt >= minScroll) {
                header.classList.add("down");
                header.classList.remove("up");

                clearTimeout(classTimer);
                classTimer = setTimeout(function () {
                    header.classList.add("down");
                    header.classList.remove("up");
                }, 100);

                diff = 0;
            } else if (dir == "up" && calcSt >= minScroll) {
                if (diff > 200 || calcSt < minScroll) {
                    clearTimeout(classTimer);
                    classTimer = setTimeout(function () {
                        header.classList.add("up");
                        header.classList.remove("down");
                        diff = 0;
                    }, 10);
                }
                clearTimeout(diff_timer);
                diff_timer = setTimeout(() => {
                    diff = 0;
                }, 1000);
            }

            diff += Number(lastScrollTop) - Number(calcSt);
            lastScrollTop = calcSt <= 0 ? 0 : calcSt; // For M
            last_diff = diff;
        }
    }

    scrollFrame();
}

function initScrollers() {
    document.querySelectorAll(".scroll-vertical").forEach((el) => {
        verticalScroller(el);
    });
}

function initFormChecks() {
    var validate = new Bouncer("#mc-embedded-subscribe-form", {
        messages: validationMessages,
    });

    document.addEventListener(
        "bouncerShowError",
        function (event) {
            event.target.classList.remove("success");
        },
        false,
    );

    document.addEventListener(
        "bouncerRemoveError",
        function (event) {
            event.target.classList.add("success");
        },
        false,
    );
}

function initAjaxVariations() {}

// overwrite flexslider params!
if (
    typeof wc_single_product_params !== "undefined" &&
    wc_single_product_params.flexslider
) {
    window.addEventListener("load", () => {
        const getAmount = document.querySelectorAll(
            ".flex-control-thumbs li",
        ).length;
        const lastPlus = document.querySelector(".last-plus");

        if (!lastPlus) return;

        const handleLastPlus = () => {
            lastPlus.classList.remove("last-plus");
            const spanElement = lastPlus.querySelector("span");
            if (spanElement && !spanElement.classList.contains("hidden")) {
                spanElement.classList.add("hidden");
            }
        };
        if (getAmount > 4) {
            const observer = new MutationObserver(() => {
                const element = lastPlus.querySelector("*");
                if (element && element.classList.contains("flex-active")) {
                    if (!lastPlus.classList.contains("last-plus")) {
                        return;
                    }
                    handleLastPlus();
                    observer.disconnect();
                }
            });

            observer.observe(
                document.querySelector(".woocommerce-product-gallery"),
                {
                    subtree: true,
                    childList: true,
                },
            );
        } else {
            handleLastPlus();
        }
    });

    wc_single_product_params.flexslider.directionNav = true;
}

var cartMenuCount;
function initCartQuantity() {
    cartMenuCount = document.querySelector("#menu-cart-count");

    // dirty hack for React cart
    initQuanitityUpdater();

    jQuery(document.body).on(
        "removed_from_cart updated_cart_totals added_to_cart",

        function (event, args) {
            let cartCount = args["cart_contents_count"];

            if (cartCount) {
                cartMenuCount.innerHTML = cartCount;
                cartMenuCount.classList.remove("hidden");
            } else {
                cartMenuCount.classList.add("hidden");
            }
            initQuantitySelect();
        },
    );
    jQuery(document.body).on("wc_cart_emptied", function () {
        setEmptyCart();
    });
    initQuantitySelect();
}

function setEmptyCart() {
    let cartMenuCount = document.querySelector("#menu-cart-count");
    cartMenuCount.remove();
}

function initQuantitySelect() {
    document.querySelectorAll(".quantity-selector").forEach((el) => {
        quantityInput(el);
    });

    document.querySelectorAll(".woocommerce-cart-form .qty").forEach((el) => {
        el.addEventListener("change", function () {
            document.querySelector(
                "button[name='update_cart']",
            ).disabled = false;
        });
    });
}

function initQuanitityUpdater() {
    if (document.querySelector(".wc-block-cart")) {
        setInterval(doQuantityUpdate, 1000);
    }
    if (document.querySelector(".wp-block-woocommerce-empty-cart-block")) {
        setEmptyCart();
    }
}

function doQuantityUpdate() {
    var total = 0;
    document
        .querySelectorAll(".wc-block-components-quantity-selector__input")
        .forEach((el) => {
            total += parseInt(el.value);
        });
    cartMenuCount.innerHTML = total;
    if (total == 0) {
        setEmptyCart();
    }
}

function initUspSlider() {
    const usps = document.querySelector("#usps");
    if (usps && usps.querySelectorAll(".item").length > 0) {
        verticalAutoSlider(usps, {
            startWidth: 1024,
            interval: 4000,
            speed: 1500,
        });
    }
}

function initTooltips() {
    document.querySelectorAll(".has-tooltip").forEach((el) => {
        // create custom tooltip div on hover
        tooltip(el);
    });
}
